module.exports = __webpack_public_path__ + "img/guild_master_logo.47d23cb.png";